module.exports = __webpack_public_path__ + "static/media/clients-03.643967d1.svg";